import React from 'react'
import OurBusinessStyles from './OurBusiness.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';
import DeleteConformation from '../DeleteConformation/DeleteConformation';

const OurBusiness = () => {
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();
    const [tempData, setTempData] = useState(null);



    const dispatch=useDispatch();

    const business = [1, 2, 3]

    const [data, setData] = useState([])

    const getBusinessData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/business/getAllBusinessDetails`
            )
            setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getBusinessData()
    }, [])



    const handleDeletebusiness = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSADMIN}/business/deleteById/${tempData.businessImageId}`
            ) .then((res) => {
                showToast("success", "Our Business Delete Successfully");
                handleDeleteModal();
                getBusinessData();
            })

            
            dispatch(setNotificationCount({
              count:count+1,
             }))

        } catch (error) {
            console.log(error)
        }
    }




    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }
    return (
        <>
         <Toast />
            <useBackdrop />
        <div className={OurBusinessStyles.ourbusinessMain}>
            <div className={OurBusinessStyles.ourbusinessContent}>
                <div className={OurBusinessStyles.ourbusinessHeader}>
                    <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' ,paddingBottom:'2%'}} >
                        Our Business
                    </Typography>
                    <Link to='/addbusiness'>
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Business</Button>
                    </Link>
                </div>
                <Box className={OurBusinessStyles.ourbusinessComponent}>
                    <div className={OurBusinessStyles.ourbusinessComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Name
                        </Typography>
                    </div>
                    <div className={OurBusinessStyles.ourbusinessComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Last modified
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Action
                        </Typography>
                    </div>
                </Box>
                {data.map((business) =>
                    <Box className={OurBusinessStyles.ourbusinessComponent}>
                        <div className={OurBusinessStyles.ourbusinessComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                {business.business?.businessHeading}
                            </Typography>
                        </div>
                        <div className={OurBusinessStyles.ourbusinessComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                {business.business?.date}
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                <Link to={`/business/${business?.businessImageId}`} state={business} style={{marginRight:'10%'}} >
                                    <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                </Link>
                                <IconButton disableRipple onClick={() => handleDeleteModal(business)}>
                                    <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                </IconButton>
                            </Typography>
                        </div>
                    </Box>
                ).reverse()}
            </div>
        </div>
        
        <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => handleDeletebusiness()}
                onReject={() => { }}
            >
                <h2>Delete Our Business</h2>
                <p>Are you sure you want to Delete this Our Business?</p>

            </DeleteConformation>
        </>
    )
}

export default OurBusiness